import { Stack, Typography } from '@mui/material';
import {AuditInformation} from '@store/audits/audits-information/audits-information.model';


interface ContactProps {
  auditInformation: AuditInformation;
}

const Contact = (props: ContactProps) => {
  return (
    <Stack direction="row" alignItems="center" height="100%" spacing={4} >
      {(props.auditInformation.firstName != '' || props.auditInformation.lastName != '') && (
          <Stack sx={{
            backgroundColor: '#E9EBEE',
            borderRadius: '1px',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '6px 10px',
          }} direction='row' spacing={0.5}>
            <Typography fontSize="12px" fontWeight={400} color="#192133">
              {props.auditInformation.firstName}
            </Typography>
            <Typography fontSize="12px" fontWeight={400} color="#192133">
              {props.auditInformation.lastName}
            </Typography>
          </Stack>
      )}
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Typography fontSize="14px" fontWeight={400} color="#868F9C">
          fonction
        </Typography>
        <Stack sx={{
          backgroundColor: '#E9EBEE',
          borderRadius: '1px',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '6px 10px',
        }}>
          <Typography fontSize="12px" fontWeight={400} color="#192133">
            {props.auditInformation.role ?? '-'}
          </Typography>
        </Stack>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Typography fontSize="14px" fontWeight={400} color="#868F9C">
          contact
        </Typography>
        {props.auditInformation.email != '' && (
            <Stack sx={{
              backgroundColor: '#E9EBEE',
              borderRadius: '1px',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '6px 10px',
            }}>
              <Typography fontSize="12px" fontWeight={400} color="#192133">
                {props.auditInformation.email != '' ? props.auditInformation.email : '-'}
              </Typography>
            </Stack>
        )}
        <Stack sx={{
          backgroundColor: '#E9EBEE',
          borderRadius: '1px',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '6px 10px',
        }}>
          <Typography fontSize="12px" fontWeight={400} color="#192133">
            {props.auditInformation.phoneNumber != '' ? props.auditInformation.phoneNumber : '-'}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Contact;
